<template>
  <v-row
    :style="{
      backgroundColor: riga.colore_riga,
      padding: '5px',
    }"
  >
    <ProduzioneLayoutColumn
      @click_chiusura_massiva_fasi="handleClickChiusuraMassivaFasi"
      @click_registra_art_res="handleClickRegistraArtRes"
      @click_registra_peso="handleClickRegistraPeso"
      @click_riapertura_master="handleClickRiaperturaMaster"
      @click_allegati_fase="handleClickAllegatiFase"
      @click_allegati_commessa="handleClickAllegatiCommessa"
      @click_applicazione_loghi="handleClickApplicazioneLoghi"
      @click_avanza_confezioni="handleClickAvanzaConfezioni"
      @click_avanza_contenitore="handleClickAvanzaContenitore"
      @click_avanza_contenitore_sf="handleClickAvanzaContenitoreSF"
      @click_campionatura="handleClickCampionatura"
      @click_check="transmitClickCheck"
      @click_chiusura_fase="handleClickChiusuraFase"
      @click_controllo_mp="handleClickControlloMP"
      @click_controllo_qualita="handleClickControlloQualita"
      @click_gestione_pulsanti="handleClickGestionePulsanti"
      @click_history="handleClickHistory"
      @click_lavoro_squadra="handleClickLavoroSquadra"
      @click_nascondi="handleClickNascondi"
      @click_note_commessa="handleClickNoteCommessa"
      @click_note_fase="handleClickNoteFase"
      @click_note_fase_precedente="handleClickNoteFasePrecedente"
      @click_prelievi="handleClickPrelievi"
      @click_questionario_qualita="handleClickQuestionarioQualita"
      @click_registra_fermi="handleClickRegistraFermi"
      @click_registra_imballi="handleClickRegistraImballi"
      @click_registra_pezzi="handleClickRegistraPezzi"
      @click_registra_pezzi_alternativi="handleClickRegistraPezziAlternativi"
      @click_registra_pezzi_seriali="handleClickRegistraPezziSeriali"
      @click_registra_scarti="handleClickRegistraScarti"
      @click_manutenzione="handleClickManutenzione"
      @click_registra_cont_alternativi="handleClickRegistraContAlternativi"
      @click_ristampa_seriale="handleClickRistampaSeriale"
      @click_scheda_packaging="handleClickSchedaPackaging"
      @click_scheda_richieste="handleClickSchedaRichieste"
      @click_segnalazione="handleClickSegnalazione"
      @click_start="handleClickStart"
      @click_stop="handleClickStop"
      @click_subentro="handleClickSubentro"
      @click_visualizza_allegto_controllo="
        handleClickVisualizzaAllegatoControllo
      "
      @click_visualizza_disegno="handleClickVisualizzaDisegno"
      @column_is_mounted="handleColumnIsMounted"
      :colonna="colonna"
      :gestione_team_enabled="gestione_team_enabled"
      :handleClickCheck="handleClickCheck"
      :key="i"
      v-for="(colonna, i) in riga.colonne
        ? riga.colonne.filter((c) => c.validita == 1)
        : []"
      :workorder="workorder"
    ></ProduzioneLayoutColumn>
  </v-row>
</template>
<script>
import ProduzioneRowObject from "@/classes/ProduzioneRowObject.js";

export default {
  name: "ProduzioneLayoutRow",
  components: {
    ProduzioneLayoutColumn: () =>
      import(
        "@/components/PRODUCTION/ProduzioneLayout/ProduzioneLayoutColumn.vue"
      ),
  },
  props: {
    gestione_team_enabled: { type: Number, default: 0 },
    handleClickCheck: {
      type: Function,
      default: () => {},
    },
    riga: { type: Object, default: new ProduzioneRowObject() },
    workorder: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    handleClickChiusuraMassivaFasi(arg) {
      this.$emit("click_chiusura_massiva_fasi", arg);
    },
    handleClickRegistraArtRes(arg) {
      this.$emit("click_registra_art_res", arg);
    },
    handleClickRegistraPeso(arg) {
      this.$emit("click_registra_peso", arg);
    },
    handleClickRiaperturaMaster(arg) {
      this.$emit("click_riapertura_master", arg);
    },
    handleClickAllegatiFase(arg) {
      this.$emit("click_allegati_fase", arg);
    },
    handleClickAllegatiCommessa(arg) {
      this.$emit("click_allegati_commessa", arg);
    },
    handleClickApplicazioneLoghi(arg) {
      this.$emit("click_applicazione_loghi", arg);
    },
    handleClickAvanzaConfezioni(arg) {
      this.$emit("click_avanza_confezioni", arg);
    },
    handleClickAvanzaContenitore(arg) {
      this.$emit("click_avanza_contenitore", arg);
    },
    handleClickAvanzaContenitoreSF(arg) {
      this.$emit("click_avanza_contenitore_sf", arg);
    },
    handleClickCampionatura(arg) {
      this.$emit("click_campionatura", arg);
    },
    handleClickChiusuraFase(arg) {
      this.$emit("click_chiusura_fase", arg);
    },
    handleClickControlloMP(arg) {
      this.$emit("click_controllo_mp", arg);
    },
    handleClickControlloQualita(arg) {
      this.$emit("click_controllo_qualita", arg);
    },
    handleClickGestionePulsanti() {
      this.$emit("click_gestione_pulsanti");
    },
    handleClickHistory(arg) {
      this.$emit("click_history", arg);
    },
    handleClickLavoroSquadra(arg) {
      this.$emit("click_lavoro_squadra", arg);
    },
    handleClickNascondi(arg) {
      this.$emit("click_nascondi", arg);
    },
    handleClickNoteCommessa(arg) {
      this.$emit("click_note_commessa", arg);
    },
    handleClickNoteFase(arg) {
      this.$emit("click_note_fase", arg);
    },
    handleClickNoteFasePrecedente(arg) {
      this.$emit("click_note_fase_precedente", arg);
    },
    handleClickPrelievi(arg) {
      this.$emit("click_prelievi", arg);
    },
    handleClickQuestionarioQualita(arg_wo, arg_questionario) {
      this.$emit("click_questionario_qualita", arg_wo, arg_questionario);
    },
    handleClickRegistraFermi(arg) {
      this.$emit("click_registra_fermi", arg);
    },
    handleClickRegistraImballi(arg) {
      this.$emit("click_registra_imballi", arg);
    },
    handleClickRegistraPezzi(arg) {
      this.$emit("click_registra_pezzi", arg);
    },
    handleClickRegistraPezziAlternativi(arg) {
      this.$emit("click_registra_pezzi_alternativi", arg);
    },
    handleClickRegistraPezziSeriali(arg) {
      this.$emit("click_registra_pezzi_seriali", arg);
    },
    handleClickRegistraScarti(arg) {
      this.$emit("click_registra_scarti", arg);
    },
    handleClickManutenzione(arg) {
      this.$emit("click_manutenzione", arg);
    },
    handleClickRegistraContAlternativi(arg) {
      this.$emit("click_registra_cont_alternativi", arg);
    },
    handleClickRistampaSeriale(arg) {
      this.$emit("click_ristampa_seriale", arg);
    },
    handleClickSegnalazione(arg) {
      this.$emit("click_segnalazione", arg);
    },
    handleClickVisualizzaAllegatoControllo(arg) {
      this.$emit("click_visualizza_allegto_controllo", arg);
    },
    handleClickVisualizzaDisegno(arg) {
      this.$emit("click_visualizza_disegno", arg);
    },
    handleClickSchedaPackaging(arg) {
      this.$emit("click_scheda_packaging", arg);
    },
    handleClickSchedaRichieste(arg) {
      this.$emit("click_scheda_richieste", arg);
    },
    handleClickStart() {
      this.$emit("click_start");
    },
    handleClickStop(commessa, arg_nascondi, arg_dialog) {
      this.$emit("click_stop", commessa, arg_nascondi, arg_dialog);
    },
    handleClickSubentro(arg) {
      this.$emit("click_subentro", arg);
    },
    handleColumnIsMounted(arg) {
      this.$emit("column_is_mounted", arg);
    },
    transmitClickCheck(wo, cod_btn) {
      this.$emit("click_check", wo, cod_btn);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>